import { Trans } from '@lingui/react/macro'
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from 'designSystem/components/Dialog'
import { useMediaQuery } from 'designSystem/components/useMediaQuery'
import type { ReactNode } from 'react'
import { PHONE_LANDSCAPE_QUERY } from 'utils/mobileLayout'

interface FloatingDocumentPreviewOverlayProps {
  children: ReactNode
  onClose: () => void
}

export function FloatingDocumentPreviewOverlay({
  children,
  onClose,
}: FloatingDocumentPreviewOverlayProps) {
  const isLandscapePhone = useMediaQuery(PHONE_LANDSCAPE_QUERY)

  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose()
      }}>
      <DialogContent
        layout={isLandscapePhone ? 'fill' : 'tall'}
        padding='none'
        showCloseButton={false}
        aria-describedby={undefined}>
        <DialogTitle srOnly>
          <Trans>Preview</Trans>
        </DialogTitle>
        {children}
      </DialogContent>
    </Dialog>
  )
}
